import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import type { Candidate } from '@recruitee/candidate-types';
import { WorkerPool } from '@recruitee/common';
import { HttpApiService } from '@recruitee/http';

@Injectable({ providedIn: 'root' })
export class GdprCandidateHttpClient {
  constructor(
    protected httpApi: HttpApiService,
    private workerPool: WorkerPool,
  ) {}

  public extendExpiry(
    candidateId: number,
    gdprCustomExpiresAt: string,
  ): Observable<{ candidate: Candidate; references: [] }> {
    return this.httpApi
      .post(
        `gdpr/candidates/${candidateId}/set_gdpr_custom_expires_at`,
        {},
        { gdprCustomExpiresAt },
      )
      .pipe(switchMap(data => this.workerPool.fillInReferences(data.candidate, data.references)));
  }
}
